export enum PostContentBlockTypes {
    HTML = 'HTML',
    Image = 'image',
    Quote = 'quote',
    Link = 'link',
    Bordered = 'bordered'
}
